import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  color: ${COLORS.BLACK};
  background-color: ${COLORS.WHITE};
`;
const Wrapper = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 1200px;
  width: 100%;
`;

const RegisterSection = styled.div`
  display: grid;
  padding: 26px;
  h2 {
    text-transform: uppercase;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 10px;
    font-size: 28px;
    @media (max-width: 767px) {
      font-size: 20px;
    }
  }
  p {
    font-size: 19px;
    margin-bottom: 17px;
    margin-top: 0;
    color: ${COLORS.BLACK};
    line-height: 36px;
    @media (max-width: 767px) {
      font-size: 18px;
      line-height: 26px;
    }
  }
  @media (min-width: 1024px) {
    padding: 52px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    h2 {
      grid-column: 1 / span 3;
      margin-bottom: 0;
    }
    p {
      grid-column: 1 / span 2;
    }
  }
`;

export { Container, Wrapper, RegisterSection };
